import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { SharedModule } from 'app/shared/shared.module';
import { HappyBirthdayComponent } from './components/happy-birthday/happy-birthday.component';
import { CommonModule } from '@angular/common';
import { MissionsRoutingModule } from 'app/modules/normal/missions/missions-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AnniversaryComponent } from './components/anniversary/anniversary.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { RewardComponent } from './components/reward/reward.component';
import { NewLevelComponent } from './components/new-level/new-level.component';

@NgModule({
    declarations: [
        NotificationsComponent,
        HappyBirthdayComponent,
        AnniversaryComponent,
        WelcomeComponent,
        RewardComponent,
        NewLevelComponent
    ],
    imports: [
        RouterModule,
        OverlayModule,
        PortalModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        SharedModule,
        CommonModule,
        ReactiveFormsModule,
        NgApexchartsModule,
    ],
    exports: [
        NotificationsComponent
    ]
})
export class NotificationsModule {
}
